import template from 'text!./ContactDetailsPerson.html';
import controller from './ContactDetailsPersonCtrl';

export default {
    controller,
    bindings: {contactModel: '<'},
    template: template
};
